window.PlummeI18n.register('en', {
  'err.pensionCorrection.inactive': 'No active pension payment to correct.',
  'err.pensionCorrection.legacy': 'This historical pension payment needs a reviewed accounting correction.',
  'err.pensionCorrection.stale': 'The pension payment has changed. Reload before correcting it.',
  'err.pensionCorrection.reason': 'A correction reason is required.',
  'err.pensionCorrection.reported': 'Reported payroll requires review of the A-melding before pension correction.',
  'err.pensionCorrection.settled': 'Annul the employer contribution term payment before correcting pension.',
  'err.pensionCorrection.missing': 'Pension accounting event is missing.',
  'pay.viewPensionPosting': 'View posting',
  'pay.pensionDetails': 'View payment',
  'pay.correctPensionPayment': 'Correct pension payment',
  'pay.annulPensionPayment': 'Annul pension payment',
  'pay.pensionCorrectionSaved': 'Pension payment corrected.',
  'pay.correctionReason': 'Correction reason',
  'pay.pensionCorrectionExplanation': 'The original pension payment is reversed in its original open period. A correction records a replacement payment. Payroll and salary payments remain unchanged. This changes the accounting, not a completed bank transfer.',
  'trv.approveExpense': 'Approve expense',
  'pay.taxOnNonCashBenefits': 'Tax on non-cash benefits',
  'pay.netReconciliation': 'Difference between pay items and stored net pay',
  'pay.netAdjustmentExplanation': 'Deducted from cash payout; tax is included above.',
  'pay.viewPayslip': 'View payslip',
  'pay.resendPayslip': 'Send again',
  'pay.missingPensionBankAccountReminder': 'You have not added a bank account. Remember to add the account used to pay the pension. You can still register the payment.',
  'pay.missingBankAccountReminder': 'You have not added a bank account. Remember to add the account used to pay the salary. You can still register the payment.',
});
